import { AppHeaderDropdown } from '@coreui/react'
import { DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap'
import React, { useContext } from 'react'
import AuthContext from '../../msal'
import { getSessionData } from '../../services/session/authConfig'
import { useHistory } from 'react-router-dom'

export const UserMenu = () => {
  const history = useHistory()
  const currentUser = getSessionData().loggedUser

  const authContext = useContext(AuthContext)
  const currentAccount = authContext.getUserAccount()

  const handleViewUser = () => history.push('/account')
  const handleClickLogOut = () => {
    authContext.signOut().then(() => history.push('/'))
  }

  return (
    <AppHeaderDropdown direction="down">
      <DropdownToggle nav>
        <img
          id="userIcon"
          src="user-icon.png"
          className="img-avatar"
          alt={currentAccount.username}
          title={currentAccount.username}
        />
      </DropdownToggle>
      <DropdownMenu right style={{ right: 'auto' }}>
        <DropdownItem style={{ borderBottom: '0' }} onClick={handleViewUser}>
          <i className="cui-user" /> {currentUser.firstName}
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem style={{ borderBottom: '0' }} onClick={handleClickLogOut}>
          <i className="icon-logout" /> Cerrar sesión
        </DropdownItem>
      </DropdownMenu>
    </AppHeaderDropdown>
  )
}
